import './index.css'
import React, { useEffect, useState } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Chip from '@mui/material/Chip';
import TuneIcon from '@mui/icons-material/Tune';
import BadgeIndicator from '../common/BadgeIndicator';
import InputSearch from '../common/InputSearch';
import { useNavigate } from 'react-router-dom';
import AddChip from '../common/ActionChip/AddChip';
import IndicatorChip from '../common/ActionChip/IndicatorChip';
import { NAMES_ES } from '../../assets/appConstants/constants';
import { ResetIcon } from '../common/Icons';
import { CompaniesFilterFormModel } from '../../models/company.model';


interface PrimaryMenuBarProps {
  handleOpenFilter: () => void
  setSearch: (filter: any) => void
  resetPrimaryFilter: () => void
  defaultSearchForm: CompaniesFilterFormModel
  selectedProject: string
  canEdit?: boolean
}

const PrimaryMenuBar: React.FC<PrimaryMenuBarProps> = ({ 
  handleOpenFilter, setSearch, resetPrimaryFilter, defaultSearchForm, selectedProject, canEdit = true
}) => {
  const navigate = useNavigate()
  const [appliedFilters, setAppliedFilters] = useState<{ 'key': string, 'value': string }[]>([])
  const [searchForm, setSearchForm] = useState<CompaniesFilterFormModel>(defaultSearchForm)

  const handleSearchForm = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setSearchForm({
      ...searchForm,
      [event.target.name]: event.target.value
    });
  }

  useEffect(() => resetSearchForm(), [selectedProject])

  const resetSearchForm = () => {
    setSearchForm({
      ...defaultSearchForm
    })
  }

  const onSubmitSearch = () => {
    setSearch(searchForm)
    resetSearchForm()
  }

  const onResetSearch = () => {
    resetSearchForm()
  }

  const onResetFilters = () => {
    resetPrimaryFilter()
  }

  const showResetButton = () => {
    return appliedFilters.length === 1
  }

  return (
    <React.Fragment>
      <CssBaseline />
      <div className='companies-listing-primarybar-box' >
        <div className='companies-listing-primarybar-left'>
          <span className='companies-listing-searchtkt'>
            <InputSearch
              name='number'
              value={searchForm.name}
              placeholder='Nombre de Compañía'
              onChange={handleSearchForm}
              onSubmitSearch={onSubmitSearch}
              onResetSearch={onResetSearch}
            />
          </span>

          {(appliedFilters.length > 0) && (
            <div className='companies-listing-primarybar-left__sep'><p>|</p></div>
          )}

          {appliedFilters.map((item, index) => (
            <div key={index}>
              <IndicatorChip
                label={<span>
                  <span className='applied-filters__name'>{NAMES_ES[item.key]}:</span> {item.value}
                </span>} />
            </div>
          ))}

          {showResetButton() && (
            <ResetIcon onClick={onResetFilters} className='applied-filters__reset' />
          )}
        </div>

        {(selectedProject) && (
          <div className='companies-listing-actions-toolbar__item-right'>
            <BadgeIndicator
              element={(<Chip
                icon={<TuneIcon color='success' />}
                label='Filtros'
                clickable
                onClick={handleOpenFilter} />)
              }
              indicator={appliedFilters.length === 0 ? null : appliedFilters.length}
            />

            {canEdit && (
              <AddChip
                onClick={() => navigate('/company/create')}
                label='Nueva Compañía'
              />
            )}
          </div>
        )}
      </div>
    </React.Fragment>
  );
}

export default PrimaryMenuBar
